import { assignSafe } from '@summit/core';

export enum ViewType {
  Standard = 0,
  Custom = 1,
  Shared = 2
}

export class ViewInfo {
  id: string;
  type: ViewType;
  name: string;

  constructor(jsonData?: any) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
